var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<p class=\"form-control-static\">{{:: vm.gettext(\"Keine Konfiguration notwendig. Dieser Paramter wird vom System selbst verwaltet.\") }}</p>");;return buf.join("");
}